import { Base } from './base.model';
import { Channel } from './channel.model';
import { Company } from './company.model';

export class ScheduleWeek {
  monday: ScheduleDay;
  tuesday: ScheduleDay;
  wednesday: ScheduleDay;
  thursday: ScheduleDay;
  friday: ScheduleDay;
  saturday: ScheduleDay;
  sunday: ScheduleDay;
}

export class ScheduleDay {
  actived: boolean;
  startTime: string;
  endTime: string;
}

export interface Department extends Base {
  name: string;
  description: string;
  image: string;
  company: Company;
  channel: Channel;
  schedules: ScheduleWeek;
}
